import React from 'react';
import flatten from 'lodash/flatten';
import map from 'lodash/map';
import PageExport from './PageExport';
import PageHeader from './PageHeader';
import Script from './Script';
import ScriptOptions from './ScriptOptions';
import PageId from './PageId';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

class SurveyEditorExport extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {item} = this.props;
        const items = flatten(map(item.editor.pages, 'items'));
        const parameters = item.parameters;
        const extraFields = item.extraFields;

        return (
            <>
                <div className="row">
                    {item.editor.pages.map((p, index) => (
                        <div key={index} className="survey-export-item col-12">
                            <div className="col-12 text-center mb-4">
                                <PageId id={p.id} />
                            </div>

                            {p.preScripts.length > 0 &&
                                <>
                                    <div className="col-12 text-center">
                                        <FormattedMessage {...messages.surveys.form.title.preScript} />
                                    </div>
                                    <div className="col-12 mt-2 mb-2 script">
                                        <Script scripts={p.preScripts} items={items} parameters={parameters} extraFields={extraFields} />
                                    </div>
                                </>
                            }

                            {p.optionsScripts && p.optionsScripts.length > 0 &&
                                <>
                                    <div className="col-12 text-center">
                                        <FormattedMessage {...messages.surveys.form.title.optionScript} />
                                    </div>
                                    <div className="col-12 mt-2 mb-2 script">
                                        <ScriptOptions scripts={p.optionsScripts} items={items} parameters={parameters} extraFields={extraFields} />
                                    </div>
                                </>
                            }

                            {p.rowsScripts && p.rowsScripts.length > 0 &&
                                <>
                                    <div className="col-12 text-center">
                                        <FormattedMessage {...messages.surveys.form.title.rowScript} />
                                    </div>
                                    <div className="col-12 mt-2 mb-2 script">
                                        <ScriptOptions scripts={p.rowsScripts} items={items} parameters={parameters} extraFields={extraFields} />
                                    </div>
                                </>
                            }

                            <div className="item-container">
                                <div className="item-header mt-2">
                                    <PageHeader item={p} />
                                </div>
                                <div className="col-12 item-content mb-2">
                                    <div className="item-data ml-2 mr-2">
                                        <PageExport key={p.id} page={p} items={items} parameters={parameters} extraFields={extraFields} />
                                    </div>
                                </div>
                            </div>

                            {p.postScripts.length > 0 &&
                                <div className="col-12 mt-2 mb-2 script">
                                    <Script scripts={p.postScripts} items={items} parameters={parameters} extraFields={extraFields} />
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </>
        );
    }
}

export default SurveyEditorExport;
